import React from 'react';
import { Button } from '@mui/material';
import {
  getDefaultValueCustomResource,
  getMergePackageName,
  getPackageName,
} from '@src/services/package';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import route from '@src/constants/route';
import useUserInfo from '@src/hooks/useTtsUser';
import PackageContainer from './components/PackageContainer';
import PackageV2 from './PackageV2';

const SubscriptionCustom = ({
  packageInfo = {},
  usingOrder = {},
  totalRemainingCredits,
  isMobile,
  lastUsingOrder,
}) => {
  const { i18n } = useTranslation();
  const { t, language } = i18n;
  const history = useHistory();
  const { ttsUser } = useUserInfo();

  const { packageExpiryDate } = usingOrder;
  const { type } = packageInfo;

  const { packageExpiryDate: lastOrderPackageExpiryDate } =
    lastUsingOrder || {};

  const {
    defaultCredits = 0,
    defaultDevices = 0,
    defaultVoiceClonings = 0,
  } = getDefaultValueCustomResource(packageInfo?.customResource) || {};

  const handleRedirectToBuyPackage = () => {
    const redirectUrl = `${route.PAYMENT}?package=${packageInfo?.code}&credits=${defaultCredits}&devices=${defaultDevices}&voiceClonings=${defaultVoiceClonings}`;
    history.push(redirectUrl);
  };

  const isLockedCustom =
    ttsUser?.studio?.custom?.remainingCredits &&
    ttsUser?.studio?.custom?.isLocked;

  const renderPackageButton = () => (
    <Button
      fullWidth
      className="buy-more-btn"
      onClick={handleRedirectToBuyPackage}
    >
      {t('buyNow')}
    </Button>
  );

  return (
    <PackageContainer
      packageName={getPackageName(
        packageInfo?.name,
        packageInfo?.code,
        language,
        t,
        true,
      )}
      productType={t(`${getMergePackageName(type)}`)}
      renderDescription={() => null}
      renderButton={renderPackageButton}
      packageDetail={
        <PackageV2
          credits={totalRemainingCredits}
          packageExpiryDate={packageExpiryDate}
          isMobile={isMobile}
          isLocked={isLockedCustom}
          isCustomPackage
        />
      }
      isMobile={isMobile}
      packageNameLastOrder={getPackageName(
        lastUsingOrder?.package?.name,
        lastUsingOrder?.package?.code,
        language,
        t,
        true,
      )}
      lastOrderPackageExpiryDate={lastOrderPackageExpiryDate}
    />
  );
};

export default SubscriptionCustom;
